export default __webpack_public_path__ + "1b60a5c47296a4388e0cdf372267efbb.jpg";